const HeroBanner = () => {
  return (
    <section className="relative h-[60vh] rounded-[20px] overflow-hidden mx-8 mt-32 mb-16">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/4ef4608a6295633248ea6211c4378810.jpg"
          alt="Professional Styling Tools"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
      </div>

      <div className="absolute bottom-0 left-0 p-12 text-white">
        <h1 className="text-6xl font-bold font-serif mb-3">Our Services</h1>
        <p className="text-lg font-sans font-light">Expertise in every detail</p>
      </div>
    </section>
  );
};

export default HeroBanner;